import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from "react";
import { useEditor } from "../../hooks/EditorProvider";
import draggableComponents from "./draggableComponents";
import { draggableElements } from "./draggableElements";
const DraggableComponent = ({ item, elementId, index, ...rest }) => {
    const { dragOverComponent, mode, iframeMount, draggableAddComponent, setDragActive, } = useEditor();
    const isEditor = mode !== "production";
    const draggableElement = useMemo(() => draggableElements.find((e) => e.type === item.type), [item.type]);
    const handleDragStart = (e) => {
        e.target?.classList.add("editor-is-dragging");
        setDragActive(true);
        if (e.target?.getAttribute("editor-key") === item.id) {
            e.dataTransfer.setData("editor-component-drag-type", item.type);
            e.dataTransfer.setData("editor-component-drag-item", JSON.stringify(item));
            e.dataTransfer.setData("editor-component-element-id", elementId);
        }
    };
    const handleDragOver = (e) => {
        e.preventDefault();
        const findParent = iframeMount
            ?.querySelector(`[editor-elementid='${elementId}']`)
            ?.querySelector(`[editor-key='${item.id.split("/").slice(0, -1).join("/")}']`);
        if (e.target?.getAttribute("editor-key") === item.id) {
            if (findParent) {
                findParent.classList.add("editor-parent-selected");
            }
            iframeMount
                ?.querySelector(`[editor-elementid='${elementId}']`)
                ?.querySelector(`[editor-key='${item.id}']`)
                .classList.add("editor-is-drag-over");
            dragOverComponent.current = item.id;
        }
    };
    const handleDragLeave = (e) => {
        iframeMount.querySelectorAll(".editor-parent-selected").forEach((el) => {
            el.classList.remove("editor-parent-selected");
        });
        if (e.target?.getAttribute("editor-key") === item.id) {
            iframeMount
                ?.querySelector(`[editor-elementid='${elementId}']`)
                ?.querySelector(`[editor-key='${item.id}']`)
                .classList.remove("editor-is-drag-over");
            dragOverComponent.current = null;
        }
    };
    const handleDragEnd = (e) => {
        e.target?.classList.remove("editor-is-dragging");
        setDragActive(false);
    };
    const handleDrop = (e, force = false) => {
        e.preventDefault();
        if (!force && e.target?.getAttribute("editor-key") !== item.id)
            return;
        const componentType = e.dataTransfer.getData("editor-component-drag-type");
        const componentData = e.dataTransfer.getData("editor-component-drag-item");
        const componentElementId = e.dataTransfer.getData("editor-component-element-id");
        iframeMount.querySelectorAll(".editor-parent-selected").forEach((el) => {
            el.classList.remove("editor-parent-selected");
        });
        if (componentType) {
            const cData = componentData ? JSON.parse(componentData) : null;
            let dropItem = item?.id;
            let dropIndex = index;
            if (draggableElement?.allowedChildren.length === 0 ||
                !draggableElement?.allowedChildren.includes("*") ||
                draggableElement?.allowedChildren.includes(componentType)) {
                dropItem = item?.id.split("/").slice(0, -1).join("/");
                // dropIndex = null;
            }
            if (dropItem === cData.id)
                return;
            setDragActive(false);
            iframeMount
                ?.querySelector(`[editor-elementid='${elementId}']`)
                ?.querySelector(`[editor-key='${item.id}']`)
                .classList.remove("editor-is-drag-over");
            draggableAddComponent(dropItem, componentType, elementId, cData, dropIndex, componentElementId);
        }
    };
    const defaultDragProps = isEditor
        ? {
            draggable: true,
            onDragStart: handleDragStart,
            onDragOver: handleDragOver,
            onDragLeave: handleDragLeave,
            onDrop: handleDrop,
            onDragEnd: handleDragEnd,
        }
        : {};
    const animationAttributes = {
        "data-aos": item?.props?.animation?.variant,
        "data-aos-delay": item?.props?.animation?.delay,
    };
    const defaultProps = {
        "editor-type": item.type,
        "editor-component": item?.props?.component,
        "editor-highlightable": "true",
        ...animationAttributes,
        ...defaultDragProps,
        ...rest,
    };
    const DraggableComponent = draggableComponents[item.type];
    return DraggableComponent ? (_jsx(_Fragment, { children: _jsx(DraggableComponent, { elementId: elementId, item: item, ...defaultProps }) })) : (_jsxs("div", { children: ["Not found ", item.type] }));
};
export default DraggableComponent;
//# sourceMappingURL=DraggableComponent.js.map